import storage from '../factory/StorageFactory';
import config from '../appconfig/config.json';

const dynamicSort = (property) =>{
    var sortOrder = 1;

    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a,b) {
        if(sortOrder == -1){
            return b[property].localeCompare(a[property]);
        }else{
            return a[property].localeCompare(b[property]);
        }        
    }
}

const mask = (word,num) =>  {
    if(word){
        if (word.length <= num) {
            return word;
          } else {
            var masked = word.substring(0, word.length - num).replace(/[a-z\d]/gi,"X") + 
            word.substring(word.length - num, word.length)
            return masked;
          }
    }
}

const getObjInArray = (iValue, array) => {
    let result = {};
    if(iValue !== null){
        try {
            result = array.find( ({ value }) => value === iValue);
            if(result === undefined){
                return {value:'',label:''};
            }
            
            return result;
        }
        catch(e) {
        }
    }
}

const getDesignationbyIDNum = (idNumValue, array) => {
 
    let result = {};
    if(idNumValue !== null) {
        try {
   
            result = array.find(({ IDNum }) => IDNum === idNumValue);
           
            if(result === undefined){
                return '';
            }
            return result.Designation;
        
        }
        catch(e) {
            // console.log('getDesignationbyIDNum ',e)
        }
    }
}

const getObjInArraybyIDNum = (idNum, array) => {
    let result = {};
    if(idNum !== null){
        try {
            result = array.find( ({ IDNum }) => IDNum === idNum);
            return result;
        }
        catch(e) {
        }
    }
}

const filterArrayByValue = (array, fValue) => {
    let result  = [];
    
    if(fValue !== null){
        result = array.filter(obj => obj.value !== fValue);
    }
     
    return result;
}

const filterArrayByName= (array, name) => {
    let result  = [];
    
    if(name !== null){
        result = array.filter(obj => obj.Name !== name);
    }
     
    return result;
}

const filterArrayById = (array, id) => {
    let result = array.filter(obj => obj.value !== id);
    return result;
}

const checkTokenExpired = () => {
    if(storage.getTokenExpiry()){
        let tokenExpirationDate = new Date(storage.getTokenExpiry());
        let currentDate = new Date();
        if(tokenExpirationDate.getTime() > currentDate){
           // return false;
           return true;
        }
        else {
           // return true;
           return false;
        }
    }
}

const getLabelInArray = (iValue, array) => {
    try{
        if(iValue == null){
            return '';
        }

        const obj = array.find(({ value }) => value === iValue);
        let result = '';
        if(obj){
            result = obj.label;
        }
        return result;
    } catch(ex){

    }
}

const validateNoOfCheckedBox = (data, min, max) => {
    let result = true;
    let count = 0;
    let dataArray =  Object.values(data);
 
    for(let i in dataArray){
        if(dataArray[i] === true){
             count++;
        }
    }

    if( count < min || count > max) {
         result = false;
    }
    else{
        result = true;
    }
    
    return result;
}

const getBaseApiUrl = () => {
    let apiUrl = '';
    switch (config.SERVER_STATUS) {
        case "DEV": apiUrl = config.Domain.DEV
        break;
        case "SIT": apiUrl = config.Domain.SIT 
        break;
        case "UAT": apiUrl = config.Domain.UAT 
        break;
        case "PROD": apiUrl = config.Domain.PROD 
        break;
        case "SIM": apiUrl = config.Domain.SIM 
        break;
        default:
        break;
    }
    return apiUrl;
}

const getPdfUrl = (pdfName) => {
    let url = getBaseApiUrl();
    return url+'/rsme/'+pdfName;
}

const getProductPageUrl = (prodType) => {
    let url = getBaseApiUrl();
    return url+'/rsme/?option='+prodType;
}

const getConsentPageUrl = (refNo) => {
    let url = getBaseApiUrl();
    return url+'/rsme/Consent?referenceno='+refNo+'&value=False';
}
/*
const isTokenExpired = () => {
    let isExpired = false;
    const token = storage.getTokenExpiry();
    if(!token){
        isExpired = false;
    }
    else {
        let localExpTime = new Date(token).getTime();
        let currentTime = new Date();
        currentTime = currentTime.getTime();
        if(currentTime >= localExpTime) {
            isExpired = true;
        }
    }
    return isExpired;
}
*/

const isTokenExpired = () => {
    let isExpired = false;
    const token = storage.getTokenExpiry();
    if(!token){
        isExpired = false;
    }
    else {
        let currentTime, offset,utc,nd;
        let localExpTime = new Date(token).getTime();
        currentTime = new Date();
        utc = currentTime.getTime()+(currentTime.getTimezoneOffset()*60000);
        offset = 8;
        nd = new Date(utc+(3600000*offset));
 
        if(nd >= localExpTime) {
            isExpired = true;
        }
    }
   
    return isExpired;
}

const dataURLtoFile = (dataurl, filename) => {
 
    const arr = dataurl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while(n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, {type:mime});
}

const extractImgFileExtensionFromBase64 = (base64ImgData) => {
    return base64ImgData.substring('data:image/'.length,base64ImgData.indexOf(';base64'));
}

const base64ImgtoFile = (base64ImgData, filename) => {
    const arr = base64ImgData.split(',')
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while(n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, {type:mime});
}
 
const isInvalidState = () => {
   const sid= storage.getStateId();
   if(sid) {
    return false;
   }
   else {
    return true;
   }
}

export default {
    dynamicSort,
    mask,
    getObjInArray,
    filterArrayByValue,
    filterArrayById,
    checkTokenExpired,
    validateNoOfCheckedBox,
    filterArrayByName,
    getObjInArraybyIDNum,
    getLabelInArray,
    getDesignationbyIDNum,
    getPdfUrl,
    getProductPageUrl,
    getConsentPageUrl,
    getBaseApiUrl,
    isTokenExpired,
    dataURLtoFile,
    extractImgFileExtensionFromBase64,
    base64ImgtoFile,
    isInvalidState
}